// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"10":"6d5bb9e8","325":"5a3921be"}[chunkId] + ".css";
};